/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import _isEmpty from 'lodash/isEmpty'

const FloatingLabel = ({isFocussed, value, title, hasCustomPlaceholder, isRequired}) => {
    let floatClassName = 'floating-label'

    if (!isFocussed && _isEmpty(value) && !hasCustomPlaceholder) {
        return null
    }

    if (isFocussed) {
        floatClassName = `${floatClassName} floating-label__is-focused`
    } else if (!_isEmpty(value) || hasCustomPlaceholder) {
        floatClassName = `${floatClassName} floating-label__has-value`
    }

    return title ? (
        <label data-testid="title" className={floatClassName}>
            {`${title}${isRequired ? ' *' : ''}`}
        </label>
    ) : null
}

export default FloatingLabel
